// extracted by mini-css-extract-plugin
module.exports = {"indicator":"styles_indicator__xqJeZ"};